import React, { useState } from 'react';
import { axiosInstance } from '../config';
import '../styles/RegionPromptModal.css';

const REGIONS = [
    { slug: 'centurion',      label: 'Centurion' },
    { slug: 'eastern_cape',   label: 'Eastern Cape' },
    { slug: 'freestate',      label: 'Free State' },
    { slug: 'johannesburg',   label: 'Johannesburg' },
    { slug: 'kwa_zulu_natal', label: 'KwaZulu-Natal' },
    { slug: 'limpopo',        label: 'Limpopo' },
    { slug: 'mpumalanga',     label: 'Mpumalanga' },
    { slug: 'north_cape',     label: 'Northern Cape' },
    { slug: 'north_west',     label: 'North West' },
    { slug: 'pretoria',       label: 'Pretoria' },
    { slug: 'southern_cape',  label: 'Southern Cape' },
    { slug: 'western_cape',   label: 'Western Cape' },
];

export default function RegionPromptModal({ onClose }) {
    const [selectedRegion, setSelectedRegion] = useState(localStorage.getItem('preferredRegion') || '');
    const [vitalityFirst, setVitalityFirst] = useState(localStorage.getItem('vitalityFirst') === 'true');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const handleSave = async () => {
        if (!selectedRegion) {
            setError('Please select your region to continue.');
            return;
        }
        setSaving(true);
        setError('');
        try {
            await axiosInstance.patch(
                '/users/preferences',
                { preferredRegion: selectedRegion, vitalityFirst }
            );
            localStorage.setItem('preferredRegion', selectedRegion);
            localStorage.setItem('vitalityFirst', vitalityFirst ? 'true' : 'false');
            window.dispatchEvent(new CustomEvent('region-updated', { detail: { preferredRegion: selectedRegion, vitalityFirst } }));
            onClose();
        } catch (err) {
            setError('Could not save preferences. Please try again.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="region-modal-overlay">
            <div className="region-modal-card">
                <button
                    type="button"
                    className="region-modal-close"
                    onClick={onClose}
                    aria-label="Close region preferences"
                >
                    x
                </button>
                <div className="region-modal-header">
                    <p className="region-modal-kicker">Shopping Preferences</p>
                    <h2 className="region-modal-title">Where do you shop?</h2>
                    <p className="region-modal-subtitle">
                        We'll show you ingredient prices from stores near you.
                    </p>
                </div>

                <div className="region-modal-grid">
                    {REGIONS.map(r => (
                        <button
                            key={r.slug}
                            onClick={() => setSelectedRegion(r.slug)}
                            className={`region-modal-option${selectedRegion === r.slug ? ' active' : ''}`}
                        >
                            {selectedRegion === r.slug && <span className="region-modal-check">✓ </span>}
                            {r.label}
                        </button>
                    ))}
                </div>

                <label className="region-modal-vitality-row">
                    <div className="region-modal-vitality-toggle">
                        <input
                            type="checkbox"
                            checked={vitalityFirst}
                            onChange={e => setVitalityFirst(e.target.checked)}
                            className="region-modal-checkbox"
                        />
                        <span className="region-modal-vitality-label">
                            <strong>Vitality first</strong>
                            <span className="region-modal-vitality-hint"> - show Discovery Vitality products at the top</span>
                        </span>
                    </div>
                </label>

                {error && <p className="region-modal-error">{error}</p>}

                <div className="region-modal-actions">
                    <button
                        onClick={handleSave}
                        disabled={saving}
                        className={`region-modal-save${saving ? ' disabled' : ''}`}
                    >
                        {saving ? 'Saving...' : 'Save my region'}
                    </button>
                    <button onClick={onClose} className="region-modal-skip">
                        Skip for now
                    </button>
                </div>
            </div>
        </div>
    );
}
